import { gql } from '@apollo/client';

export const ADD_EXTERNAL_COMPANY = gql`
  mutation createExternalCompanyMutation(
    $group_id: String
    $company_id: String
    $external_company: JSON
    $user_email: String
  ) {
    createExternalCompany(
      group_id: $group_id
      company_id: $company_id
      external_company: $external_company
      user_email: $user_email
    )
  }
`;

export const DELETE_EXTERNAL_COMPANY = gql`
  mutation deleteExternalCompanyMutation(
    $group_id: String
    $company_id: String
    $external_company: JSON
    $user_email: String
  ) {
    deleteExternalCompany(
      group_id: $group_id
      company_id: $company_id
      external_company: $external_company
      user_email: $user_email
    )
  }
`;

export const UPDATE_EXTERNAL_COMPANY = gql`
  mutation updateExternalCompanyMutation(
    $group_id: String
    $company_id: String
    $external_company: JSON
    $original_company_data: JSON
    $user_email: String
  ) {
    updateExternalCompany(
      group_id: $group_id
      company_id: $company_id
      external_company: $external_company
      original_company_data: $original_company_data
      user_email: $user_email
    )
  }
`;
